// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uqnUa","title":"styles_title__1Mraz"};